<template>
    <div class="wrap">
        <div class="banner">
            <img v-if="clientWidth > 768" src="~@/assets/PC/distributorMeeting/banner.png" alt="">
            <img v-else src="~@/assets/PC/distributorMeeting/banner-m.png" alt="">
        </div>
        <div class="register">
            <div class="register-body">
                <div class="register-content" :class="clientWidth > 768 ? 'flex0' : ''">
                    <div class="register-detail">
                        <el-form :model="registerForm" :rules="rules" ref="registerForm" class="registerForm">
                            <el-form-item prop="lastName" label="姓">
                                <el-input v-model.trim="registerForm.lastName" placeholder="请输入姓"></el-input>
                            </el-form-item>
                            <el-form-item prop="firstName" label="名">
                                <el-input v-model.trim="registerForm.firstName" placeholder="请输入名"></el-input>
                            </el-form-item>
                            <el-form-item prop="company" label="公司">
                                <el-input v-model.trim="registerForm.company" placeholder="请输入公司"></el-input>
                            </el-form-item>
                            <el-form-item prop="phone" label="手机号">
                                <el-input v-model.trim="registerForm.phone" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                            <el-form-item prop="email" class="form-item email_input" label="邮箱">
                                <el-input v-model.trim="registerForm.email" placeholder="请输入您的邮箱地址"></el-input>
                            </el-form-item>
                            <el-form-item prop="scope" label="职位">
                                <el-cascader v-model="ScodeItems" :options="Module.position" placeholder="请选择职位"
                                    :props="props1" @change="ScodeItem1"></el-cascader>
                            </el-form-item>
                            <el-form-item prop="scopeOther" v-if="IsOther" label="其他">
                                <el-input v-model.trim="registerForm.scopeOther" placeholder="请输入职位"></el-input>
                            </el-form-item>
                            <el-form-item prop="partnerType" label="伙伴类型">
                                <el-select v-model="registerForm.partnerType" placeholder="请选择伙伴类型" clearable>
                                    <el-option v-for="item in partners" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <div class="privacy-text">
                                <el-checkbox v-model="privacy" class="flex">
                                    我确认已阅读
                                    <a href="https://www.aveva.cn/legal/privacy-policy/" target="_blank">AVEVA
                                        隐私政策</a>
                                    并确认我的个人数据的处理详情。
                                </el-checkbox>
                            </div>
                            <el-form-item class="flex0">
                                <el-button type="info" size="medium" :loading="loading"
                                    @click="submitForm('registerForm')" class="pc-register loginBtn">提 交</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { SubmitSpecialActivity } from "@/api/register.js";

const ACTIVITY_NAME = '剑维软件分销商闭门会议'

export default {
    data() {
        return {
            props1: { multiple: false, value: 'value', label: 'text', children: 'list' },
            loading: false,
            partners: [
                { value: 'VAR', label: 'VAR' },
                { value: 'SSP', label: 'SSP' },
                { value: 'Distributor', label: 'Distributor' },
                { value: 'SI', label: 'SI' },
                { value: 'AVEVA Employee', label: 'AVEVA Employee' },
                { value: 'Other', label: 'Other' }
            ],
            ScodeItems: '',
            privacy: false,
            registerForm: {
                lastName: "",
                firstName: "",
                phone: "",
                email: "",
                company: "",
                positionId: '',
                scope: '',
                scopeOther: '',
                partnerType: '',
                activityNames: ACTIVITY_NAME
            },
            IsOther: false,
            rules: {
                lastName: [
                    { required: true, message: "请输入姓", trigger: "blur" },
                    { min: 1, max: 30, message: "长度在1个字符至30个字符之间", trigger: "blur" },
                ],
                firstName: [
                    { required: true, message: "请输入名", trigger: "blur" },
                    { min: 1, max: 30, message: "长度在1个字符至30个字符之间", trigger: "blur" },
                ],
                phone: [
                    { required: true, message: "请输入您的手机号", trigger: "blur" },
                    { pattern: /^\d+$/, message: "请输入正确的手机号", trigger: "blur" },
                ],
                email: [
                    { required: true, message: "请输入您的邮箱地址", trigger: "blur" },
                    { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
                ],
                company: [{ required: true, message: "请输入公司名称", trigger: "change" }],
                scope: [{ required: true, message: "请选择职位", trigger: "change" }],
                scopeOther: [{ required: true, message: "请输入职位", trigger: "blur" }],
                partnerType: [{ required: true, message: "请选择伙伴类型", trigger: "change" }],
            },
        }
    },
    methods: {
        ScodeItem1() {
            this.registerForm.positionId = parseInt(this.ScodeItems[0])
            this.registerForm.scope = parseInt(this.ScodeItems[1])
            var str
            this.$store.state.Module.position.filter(item => {
                item.list.filter(val => {
                    if (val.value == this.ScodeItems[1]) {
                        str = val.text
                    }
                })
            })
            if (str == '其他') {
                this.IsOther = true
            } else {
                this.IsOther = false
                this.registerForm.scopeOther = ""
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.privacy) {
                        this.loading = true;
                        const payload = {
                            lastName: this.registerForm.lastName,
                            firstName: this.registerForm.firstName,
                            company: this.registerForm.company,
                            phone: this.registerForm.phone,
                            email: this.registerForm.email,
                            positionId: this.registerForm.positionId,
                            scope: this.registerForm.scope,
                            scopeOther: this.registerForm.scopeOther,
                            partnerType: this.registerForm.partnerType,
                            activityNames: ACTIVITY_NAME
                        }
                        SubmitSpecialActivity(payload).then((res) => {
                            if (res.status == 1) {
                                setTimeout(() => {
                                    this.$alert("感谢您的提交", {
                                        confirmButtonClass: "el-button--mini",
                                        showClose: false,
                                        callback: () => {
                                            location.reload();
                                        },
                                    });
                                }, 500)
                            } else {
                                this.loading = false;
                                this.$toast(res.message);
                            }
                        }).catch(() => {
                            this.loading = false;
                        });
                    } else {
                        this.$alert("请先阅读并勾选隐私政策！", "提示", {
                            confirmButtonClass: "el-button--mini",
                            callback: () => { },
                        });
                        return false;
                    }
                } else {
                    this.loading = false;
                    return false;
                }
            });
        },
    },
    computed: {
        ...mapState(['clientWidth', 'Module'])
    },
};
</script>
<style lang="scss" scoped>
$mobil_base: 750;

@function vw($true) {
    @return ($true / $mobil_base) * 100vw;
}

.wrap {
    width: 100%;
    overflow: hidden;
    font-size: 30px;
}

.banner {
    width: 100%;
    height: auto;
    display: block;

    img {
        width: 100%;
        height: auto;
        display: block;
    }
}

.register {
    .register-body {
        padding: 15px 0;
        min-height: calc(100vh - 83px)
    }

    .register-content {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        overflow: hidden;
    }

    .register-detail {
        box-shadow: 0 0 10px #ccc
    }

    .privacy-text,
    .privacy-text label {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .el-checkbox__label {
        white-space: normal !important;
    }

    /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #606266;
    }

    .privacy-text /deep/ .el-checkbox__inner {
        margin-top: 3px;
    }

    .el-cascader {
        width: 100%;
    }
}

@media (min-width: 768px) {
    .el-form-item {
        margin-bottom: 20px;
        display: flex;

        /deep/ .el-form-item__label {
            width: 200px !important;
        }

        /deep/ .el-input__inner {
            width: 500px;
        }
    }

    .privacy-text {
        margin-left: 200px;
        margin-top: 20px;
    }

    .loginBtn {
        width: 200px;
        margin: 10px auto;
    }

    .register {
        background: #f7f7f7;

        .register-detail {
            padding: 30px 0;
            width: 850px;
            background: #fff;

            h1 {
                font-size: 20px;
                font-weight: bold;
                color: #363d42;
                line-height: 46px;
                text-align: center;
                margin-bottom: 15px;
            }

            .registerForm {
                width: 775px;
                margin: 0 auto;
            }
        }
    }
}

@media (max-width: 768px) {
    .banner {
        img {
            width: vw(750);
        }
    }

    .el-form-item {
        margin-bottom: 14px;
    }

    .loginBtn {
        width: vw(300);
        margin: 10px auto;
    }

    .register /deep/ .el-checkbox__label {
        white-space: normal !important;
    }

    .register {
        min-height: 100vh;
        background: #f7f7f7;

        .register-body {
            padding: 0;
        }

        .register-detail {
            padding: vw(40);
            background: #fff;
            margin: vw(40);

            h1 {
                font-size: vw(30);
                font-weight: bold;
                color: #363d42;
                line-height: vw(46);
                text-align: center;
                margin-bottom: vw(15);
            }
        }

        .privacy-text {
            margin-top: vw(40);
        }
    }
}
</style>
